<div class="card">
  <div class="card-header">
    <div class="small" *ngIf="timestamp">{{ timestamp }}</div>
    <button
      nf-icon-button="secondary"
      icon="close"
      class="btn-bare close close-button"
      ngbTooltip="Remove Error"
      (click)="onRemoveError()"
    >
      Remove Error
    </button>
  </div>
  <div class="card-body" *ngIf="isExpanded; else summary">
    <div class="error-log-buttons">
      <button
        nf-icon-button="secondary"
        icon="chevron-down"
        class="btn-bare"
        ngbTooltip="Collapse Error Log"
        (click)="toggleExpand()"
      >
        Collapse Error Log
      </button>
      <button
        nf-icon-button="secondary"
        icon="content-copy"
        class="btn-bare ml-0"
        ngbTooltip="Copy error to clipboard"
        (click)="onCopy()"
      >
        Copy
      </button>
    </div>
    <div class="error-log-content">
      <div *ngFor="let item of truncatedHeliosError | keyvalue">
        <strong>{{ item.key }}</strong
        >: {{ item.value }}
      </div>
    </div>
  </div>
</div>

<ng-template #summary>
  <div class="card-body">
    <div class="error-log-buttons">
      <button
        nf-icon-button="secondary"
        icon="chevron-right"
        class="btn-bare"
        ngbTooltip="Expand Error Log"
        (click)="toggleExpand()"
      >
        Expand Error Log
      </button>
      <button
        nf-icon-button="secondary"
        icon="content-copy"
        class="btn-bare ml-0"
        ngbTooltip="Copy error to clipboard"
        (click)="onCopy()"
      >
        Copy
      </button>
    </div>
    <div class="error-log-content">
      <p class="small mb-0">{{ message }}</p>
    </div>
  </div>
</ng-template>
